import React from "react";
import ReactDOM from "react-dom/client";
import feather from "feather-icons";
import "./App.css";
import App from "./App";

// Make feather globally available so components can call window.feather.replace()
window.feather = feather;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
